export function useTypeMeta(type = 'all') {
    const map = {
        must_see: {
            icon: 'camera',
            label: 'Must see',
            bgColor: 'bg-indigo-500/40',   // background with opacity
            color: 'text-indigo-500',       // text color full opacity
        },
        food_and_drinks: {
            icon: 'food',
            label: 'Food and Drinks',
            bgColor: 'bg-amber-500/40',
            color: 'text-amber-500',
        },
        shopping: {
            icon: 'shopping',
            label: 'Shopping',
            bgColor: 'bg-yellow-500/40',
            color: 'text-yellow-500',
        },
        amusement: {
            icon: 'amusement',
            label: 'Amusement',
            bgColor: 'bg-rose-500/40',
            color: 'text-rose-500',
        },
        park: {
            icon: 'tree',
            label: 'Nature',
            bgColor: 'bg-green-500/40',
            color: 'text-green-500',
        },
        activity: {
            icon: 'sport',
            label: 'Activity',
            bgColor: 'bg-red-500/40',
            color: 'text-red-500',
        },
        services: {
            icon: 'info',
            label: 'Services',
            bgColor: 'bg-stone-500/40',
            color: 'text-stone-500',
        },
        transportation: {
            icon: 'bus',
            label: 'Transportation',
            bgColor: 'bg-emerald-500/40',
            color: 'text-emerald-500',
        },
        parking: {
            icon: 'parking',
            label: 'Parking',
            bgColor: 'bg-blue-500/40',
            color: 'text-blue-500',
        },
        all: {
            icon: 'show',
            label: 'All',
            bgColor: 'bg-gray-500/40',
            color: 'text-gray-500',
        },
    };

    return map[type] || map['all'];
}
